import {
  CartAddState,
  IBookingProceed,
  ICartData,
  ICheckout,
  paymentMethodType,
} from "../types";

export const defaultCartState: ICartData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  userId: "",
  userType: "",
  subTotal: 0,
  totalShipmentCapacity: 0,
  shipmentCharges: 0,
  totalPrice: 0,
  cartItems: [],
  taxAmount:0
};
export const defaultBookingProceed: IBookingProceed = {
  orderId: "",
  payment_id: "",
  key: "",
  public_key: "",
  paymentMethod: paymentMethodType.stripe,
};
export const defaultCheckoutForm: ICheckout = {
  customerInfo: {
    firstName: "",
    lastName: "",
    japaneseFirstName: "",
    japaneseLastName: "",
    postCode: "",
    district: "",
    state: "",
    streetAddress: "",
    mobileNumber: "",
    email: "",
    companyName: "",
    japaneseCompanyName: "",
    department: "",
  },
  sameAsCustomerInfo: false,
  shippingAddress: {
    firstName: "",
    lastName: "",
    japaneseFirstName: "",
    japaneseLastName: "",
    postCode: "",
    district: "",
    streetAddress: "",
    mobileNumber: "",
    companyName: "",
    japaneseCompanyName: "",
    department: "",
    state: "",
  },
  remarks: "",
  deliveryTimeSlot: "",
  paymentMethod: paymentMethodType.stripe,
};

export const initialState: CartAddState = {
  list: { ...defaultCartState },
  offlineList: [],
  loading: false,
  buttonLoading: false,
  search: "",
  pageNo: 0,
  pageSize: 0,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  checkoutForm: { ...defaultCheckoutForm },
  bookingProceedForm: { ...defaultBookingProceed },
  stateList: [],
  cartSummary: {
    shipmentCharges: 0,
    subTotal: 0,
    taxAmount: 0,
    totalPrice: 0,
  },
  storeList: [],
};
